<app-material-table
  [fields]="fields"
  [schema]="schema"
  [data]="data"
  [dataSource]="dataSource">
</app-material-table>
